import type { ComponentProps, MouseEvent } from 'react';

import { Slot } from '@radix-ui/react-slot';
import { cn } from '@repo/lib/cn';

import { useNotificationsSheet } from '@/components/features/notifications/NotificationSheetProvider';
import { Button } from '@/components/ui/button';

export default function NotificationsSheetTrigger(notificationSheetTrigger: ComponentProps<typeof Button>) {
  const { className, asChild = false, onClick, ...props } = notificationSheetTrigger;

  const { onOpenChange } = useNotificationsSheet();

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    onClick?.(e);
    onOpenChange(true);
  };

  const Comp = asChild ? Slot : 'button';
  return <Comp className={cn(className)} onClick={handleClick} {...props} />;
}
